import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Clock, Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../utils/api';

const DIRECTION = ['owner', 'manager', 'directeur', 'gerant', 'gérant', 'admin', 'patron', 'direction'];

export const TrialBanner = () => {
  // DISABLED (June 2026, owner request): free-trial banner removed.
  return null;
};

